// @ts-nocheck
(function () {
  function getActiveHeadline(section) {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    return section.querySelector(isMobile ? '.ImageFillStory__headline--mobile' : '.ImageFillStory__headline--desktop');
  }

  function buildSegmentContent(text) {
    const fragment = document.createDocumentFragment();
    const words = text.trim().split(/\s+/);

    words.forEach((word, wordIndex) => {
      if (wordIndex > 0) {
        fragment.appendChild(document.createTextNode(' '));
      }

      const wordNode = document.createElement('span');
      wordNode.className = 'FactoryStorySection__word';

      Array.from(word).forEach((character) => {
        const charNode = document.createElement('span');
        const baseNode = document.createElement('span');
        const fillNode = document.createElement('span');

        charNode.className = 'FactoryStorySection__char';
        baseNode.className = 'FactoryStorySection__charBase';
        fillNode.className = 'FactoryStorySection__charFill FactoryStorySection__charFill--dark';
        fillNode.setAttribute('data-image-fill-char', '');
        fillNode.setAttribute('data-segment-char', '');

        baseNode.textContent = character;
        fillNode.textContent = character;

        charNode.appendChild(baseNode);
        charNode.appendChild(fillNode);
        wordNode.appendChild(charNode);
      });

      fragment.appendChild(wordNode);
    });

    return fragment;
  }

  function prepareSegment(segment) {
    if (!segment || segment.dataset.imageFillPrepared === 'true') return;

    const base = segment.querySelector('.FactoryStorySection__segmentBase');
    const fill = segment.querySelector('[data-segment-fill]');

    if (!base || !fill) return;

    const text = base.textContent || fill.textContent || '';
    segment.textContent = '';
    segment.appendChild(buildSegmentContent(text));
    segment.dataset.imageFillPrepared = 'true';
  }

  function setFinalState(section) {
    section.querySelectorAll('[data-image-fill-char]').forEach((char) => {
      char.style.opacity = '1';
    });

    section.querySelectorAll('[data-image-fill-reveal]').forEach((reveal) => {
      reveal.style.opacity = '1';
      reveal.style.transform = 'translateY(0)';
    });
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setNativeScrollState(section, reveal, scrollLabel) {
    const activeHeadline = getActiveHeadline(section);
    const chars = activeHeadline ? Array.from(activeHeadline.querySelectorAll('[data-image-fill-char]')) : [];
    const rect = section.getBoundingClientRect();
    const scrollDistance = Math.max(section.offsetHeight - window.innerHeight, 1);
    const progress = clamp(-rect.top / scrollDistance, 0, 1);
    const fillProgress = clamp((progress - 0.08) / 0.62, 0, 1);
    const revealProgress = clamp((progress - 0.72) / 0.18, 0, 1);
    const staggerWindow = 10;
    
    chars.forEach((char, index) => {
      const charProgress = clamp((fillProgress * (chars.length + staggerWindow) - index) / staggerWindow, 0, 1);
      char.style.opacity = charProgress.toFixed(3);
    });

    if (reveal) {
      reveal.style.opacity = revealProgress.toFixed(3);
      reveal.style.transform = `translateY(${(18 * (1 - revealProgress)).toFixed(2)}px)`;
    }

    if (scrollLabel) {
      scrollLabel.style.opacity = clamp(1 - progress * 3, 0, 1).toFixed(3);
    }
  }

  function initImageFillStory(section) {
    if (section.dataset.imageFillReady === 'true') return;
    section.dataset.imageFillReady = 'true';

    const segments = Array.from(section.querySelectorAll('[data-image-fill-segment]'));

    segments.forEach(prepareSegment);

    const chars = Array.from(section.querySelectorAll('[data-image-fill-char]'));
    const reveal = section.querySelector('[data-image-fill-reveal]');
    const scrollLabel = section.querySelector('.ImageFillStory__scroll');

    if (!chars.length) {
      setFinalState(section);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setFinalState(section);
      return;
    }

    let ticking = false;

    const update = () => {
      ticking = false;
      setNativeScrollState(section, reveal, scrollLabel);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    setNativeScrollState(section, reveal, scrollLabel);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function bootImageFillStories() {
    document.querySelectorAll('[data-image-fill-story]').forEach(initImageFillStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootImageFillStories);
  } else {
    bootImageFillStories();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    event.target.querySelectorAll('[data-image-fill-story]').forEach(initImageFillStory);
  });
})();